/**
 * Compact pill-style country switcher used on the Partner Landing pages
 * so a partner can flip between /partner (UAE/Dubai) and /in/partner (India)
 * without leaving the funnel.
 */
import { useNavigate, useLocation } from 'react-router-dom';

const PartnerCountrySwitch = ({ active = 'UAE' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (region) => {
    if (region === active) return;
    if (region === 'IN') {
      try { localStorage.setItem('dreamlife_country', 'india'); } catch { /* ignore */ }
      navigate('/in/partner');
    } else {
      try { localStorage.setItem('dreamlife_country', 'uae'); } catch { /* ignore */ }
      // Keep the original UAE page reachable from the SEO-friendly /partner URL too.
      navigate(location.pathname.startsWith('/uae') ? '/uae/partner' : '/partner');
    }
  };

  const base = 'px-3 py-1.5 text-[11px] tracking-[0.2em] uppercase font-medium transition-colors';
  return (
    <div className="inline-flex rounded-full border border-white/10 bg-white/[0.03] p-1" data-testid="partner-country-switch">
      <button
        type="button"
        onClick={() => go('UAE')}
        className={`${base} rounded-full ${active === 'UAE' ? 'bg-[#C6A15B] text-black' : 'text-white/60 hover:text-white'}`}
        data-testid="partner-country-uae-btn"
      >
        Dubai · UAE
      </button>
      <button
        type="button"
        onClick={() => go('IN')}
        className={`${base} rounded-full ${active === 'IN' ? 'bg-[#C6A15B] text-black' : 'text-white/60 hover:text-white'}`}
        data-testid="partner-country-in-btn"
      >
        India
      </button>
    </div>
  );
};

export default PartnerCountrySwitch;
